import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import AdminSidebar from "../admin/AdminSidebar";
import AppContext from "../contexts/AppContext";
import ThemeContext from "../contexts/ThemeContext";
import ProductForm from "../admin/ProductForm";
import ProductsTable from "../admin/ProductTable";
import OrdersTable from "../admin/OrderTable";

const AdminDashboardCards = ({ products, orders, isDark }) => {
  const recentOrders = orders.slice(0, 3);

  return (
    <div className="row g-4 mb-4">
      <div className="col-12 col-md-4">
        <div className="card shadow-sm p-3 border-0 bg-primary text-white">
          <h2 className="h6 text-uppercase opacity-75 fw-bold">Total Products</h2>
          <p className="display-6 fw-bold mb-0">{products.length}</p>
        </div>
      </div>
      <div className="col-12 col-md-4">
        <div className="card shadow-sm p-3 border-0 bg-success text-white">
          <h2 className="h6 text-uppercase opacity-75 fw-bold">Total Orders</h2>
          <p className="display-6 fw-bold mb-0">{orders.length}</p>
        </div>
      </div>
      <div className="col-12 col-md-4">
        <div className={`card shadow-sm p-3 border-0 h-100 ${isDark ? 'border-secondary' : 'bg-white text-dark'}`} style={isDark ? { backgroundColor: '#1e1e1e', borderColor: '#444' } : {}}>
          <h2 className={`h6 text-uppercase fw-bold ${isDark ? 'text-light' : 'text-muted'}`}>Recent Orders</h2>
          <div className="mt-2">
            {recentOrders.length > 0 ? (
              recentOrders.map((order) => (
                <div key={order._id} className={`d-flex justify-content-between border-bottom py-1 small ${isDark ? 'border-secondary' : ''}`}>
                  <span className={`fw-medium text-truncate ${isDark ? 'text-light' : ''}`} style={{ maxWidth: "150px" }}>{order.customerName || "Customer"}</span>
                  <span className="text-danger fw-bold">₹{order.totalAmount || 0}</span>
                </div>
              ))
            ) : (
              <span className={`small ${isDark ? 'text-light opacity-75' : 'text-muted'}`}>No orders found</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const AdminDashboardPage = () => {
  const { adminToken } = useContext(AppContext);
  const { isDark } = useContext(ThemeContext);

  const [active, setActive] = useState("add");
  const [products, setProducts] = useState([]);
  const [orders, setOrders] = useState([]);
  const [editingProduct, setEditingProduct] = useState(null);
  const [image, setImage] = useState(null);
  const [form, setForm] = useState({ name: "", category: "", pack: "", originalPrice: "", offerPrice: "" });
  const [deleteConfirm, setDeleteConfirm] = useState({ show: false, orderId: null, orderName: "" });

  const fetchData = async () => {
    try {
      const pRes = await axios.get("https://ak-carckers-backend-api.onrender.com/api/products");
      const oRes = await axios.get("https://ak-carckers-backend-api.onrender.com/api/orders", {
        headers: { Authorization: `Bearer ${adminToken}` }
      });
      setProducts(pRes.data);
      setOrders(oRes.data);
    } catch (err) { console.error("Data Fetch Error:", err); }
  };

  useEffect(() => { if (adminToken) fetchData(); }, [adminToken]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const handleImageChange = (e) => setImage(e.target.files[0]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    Object.keys(form).forEach(key => formData.append(key, form[key]));
    if (image) formData.append("image", image);

    try {
      if (editingProduct) {
        await axios.put(`https://ak-carckers-backend-api.onrender.com/api/products/${editingProduct._id}`, formData, { headers: { Authorization: `Bearer ${adminToken}` } });
      } else {
        await axios.post("https://ak-carckers-backend-api.onrender.com/api/products", formData, { headers: { Authorization: `Bearer ${adminToken}` } });
      }
      fetchData();
      setForm({ name: "", category: "", pack: "", originalPrice: "", offerPrice: "" });
      setEditingProduct(null);
      alert("Success!");
    } catch (err) { alert("Action Failed!"); }
  };

  return (
    <div className="d-flex flex-column flex-md-row w-100 min-vh-100">
      <AdminSidebar active={active} setActive={setActive} />
      <div className={`page-shell flex-grow-1 ${isDark ? 'bg-dark text-light' : ''}`}>
        <div className="container-fluid px-4 py-4">
          <AdminDashboardCards products={products} orders={orders} isDark={isDark} />
          <hr className="my-4" style={{ opacity: "0.1" }} />
          <div className="dashboard-content-area">
            {active === "add" && <ProductForm editingProduct={editingProduct} form={form} handleChange={handleChange} handleImageChange={handleImageChange} handleSubmit={handleSubmit} setEditingProduct={setEditingProduct} setForm={setForm} setImage={setImage} />}
            {active === "products" && <ProductsTable products={products} handleEdit={(p) => { setEditingProduct(p); setForm(p); setActive("add"); }} handleDelete={async (id) => { if(window.confirm("Delete?")) { await axios.delete(`https://ak-carckers-backend-api.onrender.com/api/products/${id}`, { headers: { Authorization: `Bearer ${adminToken}` } }); fetchData(); } }} />}
            {active === "orders" && <OrdersTable orders={orders} deleteConfirm={deleteConfirm} showDeleteConfirm={(id, name) => setDeleteConfirm({ show: true, orderId: id, orderName: name })} hideDeleteConfirm={() => setDeleteConfirm({ show: false, orderId: null, orderName: "" })} confirmDeleteOrder={async () => { await axios.delete(`https://ak-carckers-backend-api.onrender.com/api/orders/${deleteConfirm.orderId}`, { headers: { Authorization: `Bearer ${adminToken}` } }); fetchData(); setDeleteConfirm({ show: false, orderId: null, orderName: "" }); }} />}
          </div>
        </div>
      </div>
    </div>
  );
};
export default AdminDashboardPage;